import { selectObjectValueByPath } from './common';
import Axios from 'axios';
import endpoints from './endpoints';

export const FILTER_ZIP_AND_COMMUNITY = 'location';
export const FILTER_ZIP = 'region.zip';
export const FILTER_REGION_COMMUNITY = 'region.community';
export const FILTER_REGION_NAME = 'address.region';
export const FILTER_LANGUAGE = 'languages';
export const FILTER_REGISTERS_LONGNAME = 'registers.longNames';
export const FILTER_LASTNAME = 'lastname';

export function readFiltersFromURL(availableFilters) {
  const params = new URLSearchParams(window.location.hash.split('?').pop());
  const filters = {};
  for (let p of params) {
    if (availableFilters.includes(p[0]) && p[1]) {
      filters[p[0]] = decodeURI(p[1]);
    }
  }
  return filters;
}

export function writeFiltersToURL(filters) {
  const params = new URLSearchParams('');
  if (Object.keys(filters).length) {
    for (const filter in filters) {
      const value = encodeURI(filters[filter]);
      params.set(filter, value);
    }
  }
  window.location.hash = `?${params.toString()}`;
}

export function getRegionByZipcode(zip, regions) {
  return regions.find(region => region.zip === zip);
}

export function getRegionByCommunity(community, regions) {
  return regions.find(region => region.community === community);
}

export function filterObjects(filters, sourceObjects) {
  return sourceObjects.filter(object => {
    if (Object.keys(filters).length) {
      for (const filter in filters) {
        const filterValue = filters[filter];
        switch (filter) {
          case FILTER_REGISTERS_LONGNAME:
            if (!selectObjectValueByPath(filter, object).includes(filterValue)) {
              return false;
            }
            break;
          case FILTER_LANGUAGE:
            if (
              !selectObjectValueByPath(filter, object)
                .map(language => language.name)
                .includes(filterValue)
            ) {
              return false;
            }
            break;
          case FILTER_ZIP:
          case FILTER_REGION_COMMUNITY:
          case FILTER_REGION_NAME:
          case FILTER_LASTNAME:
            if (selectObjectValueByPath(filter, object) !== filterValue) {
              return false;
            }
            break;
          default:
            break;
        }
      }
      return true;
    }
    return true;
  });
}

export function loadRegions(onRegionsLoaded) {
  Axios.get(endpoints.locations.REGIONS).then(res => {
    const regions = res.data.regions;
    const communitiesDistinct = [];
    const zipcodesDistinct = [];
    const zipcodeAndCommunityDistinct = [];
    const zipcodeOptions = [];
    const zipcodeAndCommunityOptons = [];
    regions.forEach(region => {
      if (!communitiesDistinct.includes(region.community)) {
        communitiesDistinct.push(region.community);
      }
      if (!zipcodesDistinct.includes(region.zip)) {
        zipcodesDistinct.push(region.zip);
        zipcodeOptions.push({ value: region.zip, label: `${region.zip} - ${region.community}` });
      }
      const zipAndCommunityValue = `${region.zip}_${region.community}`;
      if (!zipcodeAndCommunityDistinct.includes(zipAndCommunityValue)) {
        zipcodeAndCommunityDistinct.push(zipAndCommunityValue);
        zipcodeAndCommunityOptons.push({
          value: zipAndCommunityValue,
          label: `${region.zip} - ${region.community}`,
          data: { zip: region.zip, community: region.community }
        });
      }
    });
    const communityOptions = communitiesDistinct.sort().map(community => {
      return { value: community, label: community };
    });
    onRegionsLoaded(
      regions,
      communityOptions,
      zipcodeOptions.sort((optA, optB) => optA.value - optB.value),
      zipcodeAndCommunityOptons
    );
  });
}

export function getLastnameOptions(objects) {
  const lastnames = [...new Set(objects.map(obj => obj.lastname))];
  return lastnames.map(lastname => {
    return { value: lastname, label: lastname };
  });
}

export function loadRegionsDistinct(onRegionsDistinctLoaded) {
  Axios.get(endpoints.locations.REGIONS_DISTINCT).then(res => {
    const regions = res.data.regions;
    const regionOptions = regions.sort().map(region => {
      return { value: region.name, label: `${region.name}` };
    });
    onRegionsDistinctLoaded(regionOptions);
  });
}

export function loadLanguages(onLanguagesLoaded) {
  Axios.get(endpoints.locations.LANGUAGES).then(res => {
    const languages = res.data.languages;
    if (languages.length) {
      const languageOptions = languages.sort().map(lang => {
        return { value: lang.name, label: `${lang.name}` };
      });
      onLanguagesLoaded(languageOptions);
    }
  });
}

export function getZipcodeFromCombinedValue(filterValue) {
  const fractions = filterValue.split('_');
  if (fractions.length === 2) {
    return fractions[0];
  }
}

export function getCommuntyFromCombinedValue(filterValue) {
  const fractions = filterValue.split('_');
  if (fractions.length === 2) {
    return encodeURI(fractions[1]);
  }
}
